import React from 'react';

import { IonAccordion, IonItem } from '@ionic/react';

import Typography from 'components/Typography';

import { DEFAULT_ACCORDION } from './constants';
import { IAccordion } from './interfaces';

export const Accordion = ({
  title = DEFAULT_ACCORDION,
  value = title,
  children,
}: IAccordion) => {
  return (
    <IonAccordion value={value}>
      <IonItem slot={'header'} button={true} detail={false}>
        <Typography variant={'subtitle1'}>{title}</Typography>
      </IonItem>
      <div slot={'content'}>{children}</div>
    </IonAccordion>
  );
};
